import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

class HideWhenBlockedUnstyled extends React.Component {
  render() {
    const { blocked, children, className } = this.props
    const style = blocked ? className : null

    return <div className={style}>{children}</div>
  }
}

HideWhenBlockedUnstyled.propTypes = {
  blocked: PropTypes.bool.isRequired,
}

const mapStateToProps = state => ({
  blocked: state.uiBlock.uiBlockEnabled,
})

export default connect(
  mapStateToProps,
  null,
)(HideWhenBlockedUnstyled)
